import React from 'react'
import styled from 'styled-components';

const Goback = styled.div`
  font-size: 24px;
  padding: 25px 0 10px;
  border-bottom: 1px solid #787878;
  a {
    color: #3D6DE5;
    display: inline-flex;
    align-items: center;
    .icon {
      width: 24px;
      margin-right: 12px;
    }
  }
`;

export default function Back(props) {
  return (
    <Goback>
      <a href={props.url || '#/'}>
        <svg t="1620548101228" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="31441" width="32" height="32"><path d="M901.12 570.0608H187.7504V453.9392H901.12a29.0304 29.0304 0 0 1 29.0304 29.0304v58.0608a29.0304 29.0304 0 0 1-29.0304 29.0304z" fill="#3D6DE5" p-id="31442"></path><path d="M419.3792 807.8848L123.4944 512l295.8848-295.8848a29.0304 29.0304 0 0 1 40.96 0l40.96 40.96a28.928 28.928 0 0 1 0 40.96L287.6928 512l213.76 213.8112a28.928 28.928 0 0 1 0 40.96l-40.96 40.96a28.928 28.928 0 0 1-41.1136 0.1536z" fill="#3D6DE5" p-id="31443"></path></svg>
        Trias Grant
      </a>
    </Goback>
  )
}
